import { mergeStyles, NeutralColors } from '@fluentui/react';
import { Button } from '@fluentui/react-components';
import { DismissRegular, TextBulletListSquareRegular } from '@fluentui/react-icons';
import React from 'react';

const iconMap: Record<string, React.ComponentType<React.SVGAttributes<SVGElement>>> = {
  QueryList: TextBulletListSquareRegular,
};

const tagStyles = mergeStyles({
  backgroundColor: NeutralColors.gray30,
  padding: '3px 8px 3px 8px',
});

const whiteTagStyles = mergeStyles({
  backgroundColor: NeutralColors.white,
});

interface IValueTagProps {
  tagString: string | number;
  useWhiteBackground?: boolean;
  iconName?: string;
  onClick?: (itemName: string) => void;
}

const iconStyles = { marginRight: '8px' };

const ValueTag = (props: IValueTagProps): JSX.Element => {
  const { tagString, useWhiteBackground, iconName, onClick } = props;

  const tagClass = useWhiteBackground ? `${tagStyles} ${whiteTagStyles}` : tagStyles;

  const IconComponent = iconName ? iconMap[iconName] : null;

  return (
    <div className={tagClass}>
      {IconComponent && <IconComponent style={iconStyles} aria-hidden="true" />}
      {tagString}
      {onClick && (
        <Button
          appearance="subtle"
          icon={<DismissRegular />}
          aria-label={`Remove ${tagString} tag`}
          onClick={() => onClick(tagString.toString())}
        />
      )}
    </div>
  );
};

export default ValueTag;
